var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrevVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4C3.67157 4 3 4.67157 3 5.5V14.5C3 15.3284 3.67157 16 4.5 16C5.32843 16 6 15.3284 6 14.5V5.5C6 4.67157 5.32843 4 4.5 4ZM14.0331 15.6232L7.75547 11.2288C6.90239 10.6317 6.90239 9.36829 7.75547 8.77114L14.0331 4.37677C14.8616 3.79684 16 4.38953 16 5.40081V14.5992C16 15.6104 14.8616 16.2031 14.0331 15.6232Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrevVideo);
export default __webpack_public_path__ + "static/media/icon-prev-video.a6d904e79266ae5f4625befc148e07d8.svg";
export { ForwardRef as ReactComponent };